var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15175",
    "data-name": "Group 15175",
    transform: "translate(-1547 -99)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1996",
    "data-name": "Rectangle 1996",
    width: 45,
    height: 45,
    transform: "translate(1547 99)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "like",
    transform: "translate(1551 75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15172",
    "data-name": "Group 15172",
    transform: "translate(0 30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7936",
    "data-name": "Path 7936",
    d: "M27.02,30a8.711,8.711,0,0,0-5.441,1.881A12.393,12.393,0,0,0,18.4,35.708a12.392,12.392,0,0,0-3.183-3.828A8.711,8.711,0,0,0,9.773,30C4.2,30,0,34.557,0,40.6c0,6.529,5.242,11,13.177,17.759,1.348,1.148,2.875,2.45,4.463,3.838a1.15,1.15,0,0,0,1.514,0c1.588-1.389,3.115-2.69,4.463-3.839C31.552,51.6,36.794,47.13,36.794,40.6,36.794,34.557,32.592,30,27.02,30Z",
    transform: "translate(0 -30)",
    fill: "#f9b316"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadIcon2);
export default __webpack_public_path__ + "static/media/head-icon2.7de1209a3ea3736b5c46fac00b8a0abd.svg";
export { ForwardRef as ReactComponent };